var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"verify",on:{"click":function($event){$event.preventDefault();return _vm.goRegistration.apply(null, arguments)}}},[_c('span',[_vm._v("完成會員驗證享有完整功能")]),_c('span',[_vm._v("前往驗證")]),_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-chevron-right","size":"sm"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }